import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Type from '@/plugins/sdk/resources/Asset/Type'
import Manufacturer from '@/plugins/sdk/resources/Asset/Manufacturer'

export default class extends Resource {
  static name = 'assetmanufacturer_model'
  static label = 'name'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      description: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      type: new ITEM(Type),
      asset_manufacturer: new ITEM(Manufacturer)
    }
  }
}
